import { Pipe, PipeTransform } from '@angular/core';
import { IRespondentAnswerReference } from '../models/data-capture.models';

@Pipe({
  name: 'respondentAnswer',
  standalone: false,
})
export class RespondentAnswerPipe implements PipeTransform {
  transform(
    value: string,
    citations: IRespondentAnswerReference[] = []
  ): string {
    const regex =
      /(\(|\[)(?:timestamp\s*)?\d{3,}-\d{3,}(?:,\s*\d{3,}-\d{3,})*(\)|\])/gi;

    return value
      .replace(regex, (match) => {
        const ranges = match
          .slice(1, -1)
          .replace(/timestamp\s*/i, '')
          .trim()
          .split(',')
          .map((r) => r.trim())
          .filter((range) => {
            const [start, end] = range.split('-').map(Number);
            return !citations.some(
              (c) => c.timestampStart === start && c.timestampEnd === end
            );
          });

        return ranges.length ? `(${ranges.join(', ')})` : '';
      })
      .replace(/\s+([.,;!?])/g, '$1')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
